export default {"src":"/_next/static/media/setup.0b1a161b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};